import React, { useState } from "react";
import moment from "moment-jalaali";
import "./style.css";
import "../../videocall/modal-vidobo/index.css";
import axios from "axios";
import { useEffect } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function PaymentCheckoutModal({ closeModal }) {
  const [checkoutTrackId, setCheckoutTrackId] = useState("");
  const [checkoutResult, setCheckoutResult] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    checkPayment();
  }, []);

  const checkPayment = async () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const paymentSuccess = params.get("success");
    const paymentStatus = params.get("status"); // 1: Paid and verified successfully, 2: Paid but not verified, 3: Canceled by user
    const paymentTrackId = params.get("trackId");

    setCheckoutTrackId(paymentTrackId);

    const request = await axios.post("https://gateway.zibal.ir/v1/verify", {
      merchant: "64b5296bcbbc27001bc3d658", // "zibal",
      trackId: paymentTrackId,
    });

    console.log("debbb2", request.data);
    const response = await axios.post(
      "https://request.kidiar.com/receipts/verify",
      {
        trackId: parseInt(paymentTrackId),
        result: request.data.result,
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    console.log("final response", response.data);
    setIsLoaded(true);
    if (response.data.result == 1) {
      setCheckoutResult(1);
    } else if (response.data.result == 2) {
      setCheckoutResult(2);
    } else {
      setCheckoutResult(3);
    }
  };

  const submitCheckout = () => {
    window.location.href = "/fa/panel";
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-title">نتیجه تراکنش</div>
        <div className="modal-conten">
          {checkoutResult == 0 && (
            <div className="mode-text-7">
              <p>{"در حال پردازش اطلاعات ..."}</p>
              <p>{""}</p>
              <p>{""}</p>
            </div>
          )}
          {checkoutResult == 1 && (
            <div className="mode-text-7">
              <p>{"خرید شما با موفقیت انجام شد"}</p>
              <p>{"شماره پیگیری:"}</p>
              <p>{checkoutTrackId}</p>
            </div>
          )}
          {checkoutResult == 2 && (
            <div className="mode-text-7">
              <p>{"این خرید قبلا انجام شده"}</p>
              <p>{"شماره پیگیری:"}</p>
              <p>{checkoutTrackId}</p>
            </div>
          )}
          {checkoutResult == 3 && (
            <div className="mode-text-7">
              <p>{"خرید شما ناموفق بود"}</p>
              <p>{"شماره پیگیری:"}</p>
              <p>{checkoutTrackId}</p>
            </div>
          )}
        </div>
        <div className="modal-footer mt-4 mode-bg-8">
          <button onClick={() => submitCheckout()}>متوجه شدم</button>
        </div>
      </div>
    </div>
  );
}

export default PaymentCheckoutModal;
